import React from "react";
import styles from "./Slide2.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../delivery.messages";
import { useBlocks } from "@jelly/lesson";
import config from "appConfig";

export const Slide2: React.FC = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();
  return (
    <div className={styles.root}>
      <block.image src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/delivery/delivery2.jpg`}></block.image>
      <div className={styles.caption}>{formatMessage(messages.G4_P5_S1_Cinema_PhotoCaption)}</div>
      <ul>
        <li>{formatMessage(messages.G4_P5_S1_Cinema_Item1)}</li>
        <li>{formatMessage(messages.G4_P5_S1_Cinema_Item2)}</li>
      </ul>
      <div className={styles.infoBox}>
        <block.infoBox text={formatMessage(messages.G4_P5_S1_Cinema_Note)} compact />
      </div>
    </div>
  );
};
